module.exports = __webpack_public_path__ + "494cd07c/img/send-icon.3cfb6275.svg";